module.exports = __webpack_public_path__ + "static/media/no_products.2ce89bd5.png";